import { useState } from "react";
import "../../Assets/Scss/Create_Company.scss";
import { Details, Personnal } from "./Components";

const CreateCompanyForm = () => {
  const [Tab, setTab] = useState(2);
  const Next = () => {
    setTab(2);
  };
  const HandlePre = () => {
    setTab(1);
  };

  const [data, setData] = useState({
    company_name: "",
    company_location: "",
    company_email: "",
    admin_first_name: "",
    admin_last_name: "",
    admin_email: "",
    admin_phone_number: "",
  });

  return (
    <div className="Create_Wrapper">
      <h4>companies registered on i4smart</h4>
      <div className="Company_Grid">
        <Details Click={Next} data={data} setData={setData} />
        <Personnal
          Pre={HandlePre}
          setTab={setTab}
          data={data}
          setData={setData}
        />
      </div>
    </div>
  );
};

export default CreateCompanyForm;
